/**
 * Facebook Reels affichés sur la HomePage.
 * Pour ajouter une nouvelle vidéo, ajoutez un objet avec son URL Facebook Reel.
 * Format URL : https://www.facebook.com/reel/{REEL_ID}/
 *
 * Le composant FacebookSection construit automatiquement l'iframe d'embed.
 */
export const FACEBOOK_REELS = [
  {
    id: "2171967900311898",
    url: "https://www.facebook.com/reel/2171967900311898/",
    caption: "Réparation express en boutique - Mediastore Niort",
  },
];

/**
 * Construit l'URL d'embed pour un Reel Facebook.
 * Utilise le plugin officiel video.php.
 */
export const buildReelEmbedUrl = (reelUrl, opts = {}) => {
  const { width = 380, height = 476, showText = true } = opts;
  const encoded = encodeURIComponent(reelUrl);
  const showTextParam = showText ? "true" : "false";
  return `https://www.facebook.com/plugins/video.php?height=${height}&href=${encoded}&show_text=${showTextParam}&width=${width}&t=0`;
};
